import React from 'react'
import { ProductStoreProvider } from '../../contexts/product'
import { ProductTrackingProvider } from '../../contexts/tracking'
import { PageTypeEnum, ProductContext, ProductInfoProduct } from '../../types'
import { hasMultipleVariants } from '../../utils/hasMultipleVariants'
import { isDigitalGiftCard } from '../../utils/isDigitalGift/isDigitalGift'
import { ProductModalProvider } from '../../contexts/productModal'
import { StyledProvidersLayout } from './styled'

export const ConciergeProductModalProviders = ({
  product,
  children,
  onAddToBasket,
}: {
  product: ProductInfoProduct
  children: React.ReactNode
  onAddToBasket?: ProductContext['onAddToBasket']
}) => {
  const hideInitialVariantSelection =
    hasMultipleVariants(product.variants) &&
    isDigitalGiftCard(product.category.department)
  const productContext: ProductContext = {
    pageType: PageTypeEnum.HOME,
    location: '',
    onAddToBasket,
  }

  return (
    <ProductModalProvider context={productContext}>
      <ProductStoreProvider
        initialProduct={product}
        initialVariantKey={undefined}
        hideInitialVariantSelection={hideInitialVariantSelection}
        productContext={productContext}
      >
        <ProductTrackingProvider
          pageLocation="product details | ai concierge"
          pageComponent="ai concierge"
        >
          <StyledProvidersLayout>{children}</StyledProvidersLayout>
        </ProductTrackingProvider>
      </ProductStoreProvider>
    </ProductModalProvider>
  )
}
